"use strict";

var _AsyncBoundary;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { InputLoading } from '@autoguru/components';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy, memo } from 'react';

// Lazy load the StaticMFEShadowedComponent
import { jsx as _jsx } from "react/jsx-runtime";
const LazyStaticMFEShadowedComponent = /*#__PURE__*/lazy(async () => import('@autoguru/static-mfe/static-mfe-shadowed-component/StaticMFEShadowedComponent'));
export const GlobalSearch = /*#__PURE__*/memo(() => _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
  fallback: /*#__PURE__*/_jsx(InputLoading, {}),
  children: /*#__PURE__*/_jsx(LazyStaticMFEShadowedComponent, {
    width: "full",
    mfeAppName: "sp-global-search"
  })
})));